import { getCategory } from '@/api/pt';

export default {
  methods: {
    // 根据 type 和 id code 获取可选择的列表
    getCategory({
      id = '', type = '', code = '', ...rest
    }) {
      // year 所属年级 class所属班级 subjects学科 versions版本 stage阶段(根据版本获取阶段) test测试
      const keyMap = {
        year: 'grade',
        class: 'class',
        subjects: 'subject',
        versions: 'version',
        stage: 'stage',
        test: 'course',
      };
      const restParam = { ...rest };
      if (type === 'stage') {
        restParam.subjectCode = this.searchForm.subject.code;
      }
      return getCategory({
        id, type, code, ...restParam,
      }).then((res) => {
        if (res.code === 200) {
          this[`${keyMap[type]}List`] = res.data;
        }
        if (type === 'test' && res.data.length === 0) {
          this.emptyCourse = true;
        } else {
          this.emptyCourse = false;
        }
      });
    },
  },
  watch: {
    // 年级改变，班级置空
    'searchForm.grade': function resetClass() {
      this.searchForm.class = '';
    },
    // 学科改变，测试内容置空
    'searchForm.subject': function resetClass(v) {
      this.searchForm.version = '';
      this.searchForm.stage = '';
      this.searchForm.course = '';
      this.versionList = [];
      this.stageList = [];
      this.courseList = [];
      if (v) {
        this.getCategory({
          type: 'versions',
          ...v,
        });
      }
    },
    // 版本变化，改变年级
    'searchForm.version': function resetStage(v) {
      this.searchForm.stage = '';
      this.stageList = [];
      if (v) {
        this.getCategory({
          type: 'stage',
          ...v,
        });
      }
    },
    // 年级变化，改变课程
    'searchForm.stage': function resetCourse(v) {
      this.searchForm.course = '';
      this.courseList = [];
      if (v) {
        this.getCategory({
          type: 'test',
          ...v,
        });
      }
    },
  },
};
